export default{
    
    data() {
        return{
            CurPassword:'',
            NewPassword:'',
            ReNewPassword:'',
            Loading:false,
        }
    },
    mounted () {
        
    },
    methods: {
        submitpassword(){
            var me = this;
            if (me.CurPassword == null || me.CurPassword == "" ) {
                me.alert('请输入旧密码','通知');
                this.Loading = false;
                return;
            }
            if (me.NewPassword == null || me.NewPassword == "" ) {
                me.alert('请输入新密码','通知');
                this.Loading = false;
                return;
            }
            if (me.ReNewPassword == null || me.ReNewPassword == "" ) {
                me.alert('请重新输入新密码','通知');
                this.Loading = false;
                return;
            }
            if(me.NewPassword!=me.ReNewPassword)
            {
                me.alert('两次输入的新密码不一致','通知');
                this.Loading = false;
                return;
            }
            let user = JSON.parse(sessionStorage.getItem('user'));

            var method = 'Login/changepassword';

            //method=method+"?oldpassword="+me.CurPassword+'&newpassword='+me.ReNewPassword;
            this.$axios.post(method,
                    {
                        'CurrentTokenId':user.TokenId,
                        'CurrentUser':  user.LoginName,
                       'OldPassword' : me.CurPassword,
                        'NewPassword': me.ReNewPassword
                })
            .then((response) => {
                this.Loading = false;
                    if(response.data.IsSuccess)
                    {
                        /*将当前用户和Token写入缓存*/
                        this.alert('保存成功');
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        
                        this.alert(strMsg);
                    }
            })
            .catch(function (error) {
                console.log(error)
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/ChangePassword/ChangePassword.js